import React, { useState } from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";
import { useLanguage } from "../../../LanguageContext"; // Adjust the import path
import DeleteAreaModal from "./DeleteAreaModal";
import { useDispatch } from "react-redux";
import {
  deleteAreaService,
  getAllgovernoratesService,
} from "redux/services/general_service";
import { toast } from "react-toastify";
import EditAreaModal from "./EditAreaModal";
import { useTranslation } from "react-i18next";
import Input from "components/ui/Input";
import Button from "components/ui/Button";

const GovernrateTable = ({
  clients, // Rename to governorates for clarity, but keep as is if needed
  selectedClients,
  onSelectAll,
  onSelectClient,
  onDeleteClient,
  onEditClient,
  onRenewSubscription, // This might not be needed for governorates, remove if not applicable
  allSelected,
  onAddArea,
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { language } = useLanguage();
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, area: null });
  const translations = {
    id: language === "ar" ? "الرقم" : "ID",
    name: language === "ar" ? "الاسم" : "Name",
    areas: language === "ar" ? "المناطق المرتبطة" : "Areas",
    actions: language === "ar" ? "الإجراءات" : "Actions",
    edit: language === "ar" ? "تعديل" : "Edit",
    delete: language === "ar" ? "حذف" : "Delete",
    selectAll: language === "ar" ? "تحديد الكل" : "Select All",
    addArea: language === "ar" ? "إضافة منطقة" : "Add Area",
    editArea: language === "ar" ? "تعديل المنطقة" : "Edit Area",
    deleteArea: language === "ar" ? "حذف المنطقة" : "Delete Area",
  };

  // State جديدة للتصدير

  const [showExportModal, setShowExportModal] = useState(false);

  const [exportProductId, setExportProductId] = useState(null);

  const [fromDate, setFromDate] = useState("");

  const [toDate, setToDate] = useState("");

  // دالة لفتح نافذة التصدير

  const handleExportClick = (productId) => {
    setExportProductId(productId);

    setShowExportModal(true);
  };

  // دالة لتأكيد التصدير (كما طلبت، بدون تغيير)

  const handleExportConfirm = async () => {
    if (!exportProductId || !fromDate || !toDate) {
      toast.error(t("يرجى ملء جميع الحقول") || "يرجى ملء جميع الحقول");

      return;
    }

    try {
      // إنشاء رابط الـ API (استخدمت الرابط الكامل كما ذكرته)

      const url = `https://alwathiq-backend.devoracompany.com/api/v1/export/orders?area=${exportProductId}&from=${fromDate}&to=${toDate}`;

      // افتح الرابط في نافذة جديدة أو قم بتحميل الملف (افترض أن الـ API يعيد ملفاً)

      window.open(url, "_blank"); // أو استخدم fetch إذا كنت تريد تحميل مباشر

      //   toast.success(t("تم بدء التصدير") || "تم بدء التصدير");

      setShowExportModal(false);

      setExportProductId(null);

      setFromDate("");

      setToDate("");
    } catch (error) {
      toast.error(t("حدث خطأ أثناء التصدير") || "حدث خطأ أثناء التصدير");

      console.error("Export error:", error);
    }
  };

  const handleDeleteAreaClick = (area) => {
    setDeleteModal({ isOpen: true, area });
  };

  const handleConfirmDelete = (areaId) => {
    //   onDeleteArea(areaId); // استدعاء الحذف الفعلي
    dispatch(deleteAreaService(areaId)).then((response) => {
      if (response.payload?.status == 200) {
        setDeleteModal({ isOpen: false, area: null });
        toast("تم الحذف بنجاح");
        dispatch(getAllgovernoratesService());
      }
    });
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal({ isOpen: false, area: null });
  };

  return (
    <div className="overflow-hidden">
      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.id}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.name}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.areas}
              </th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {translations.actions}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {clients?.map((client) => (
              <tr key={client.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-900">
                  {client.id}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="text-sm font-medium text-gray-900">
                    {client.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="text-sm font-medium text-gray-900 space-y-1">
                    {client?.areas?.map((area, index) => (
                      <div
                        key={area.id || index}
                        className="flex items-center justify-between bg-gray-100 p-2 rounded"
                      >
                        <span>{area?.name}</span>
                        <div className="flex space-x-2">
                          <button
                            onClick={() => handleDeleteAreaClick(area)}
                            className="text-blue-600 hover:text-blue-900"
                            title={translations.editArea}
                          >
                            <Icon name="Edit" size={14} />
                          </button>

                          <button
                            className="p-1"
                            onClick={() => handleExportClick(area.id)}
                            title={t("نصدير معلومات المنطقة")}
                          >
                            <Icon name="Download" size={14} />
                          </button>
                          {/* <button
                            onClick={() => handleDeleteAreaClick(area)}
                            className="text-red-600 hover:text-red-900"
                            title={translations.deleteArea}
                          >
                            <Icon name="Trash2" size={14} />
                          </button>*/}
                        </div>
                      </div>
                    ))}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                  <div className="flex items-center justify-center space-x-2">
                    <button
                      onClick={() => onEditClient(client)}
                      className="text-green-600 hover:text-green-900"
                    >
                      <Icon name="Edit" size={16} />
                    </button>
                    <button
                      onClick={() => onDeleteClient(client.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      <Icon name="Trash2" size={16} />
                    </button>
                    <button
                      onClick={() => onAddArea(client)}
                      className="text-purple-600 hover:text-purple-900"
                      title={translations.addArea}
                    >
                      <Icon name="Plus" size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="lg:hidden">
        <div className="p-4 bg-gray-50 border-b">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={allSelected}
              onChange={(e) => onSelectAll(e.target.checked)}
              className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded mr-2"
            />
            <span className="text-sm font-medium text-gray-700">
              {translations.selectAll}
            </span>
          </label>
        </div>

        <div className="divide-y divide-gray-200">
          {clients?.map((client) => (
            <div key={client.id} className="p-4">
              <div className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  checked={selectedClients.includes(client.id)}
                  onChange={(e) => onSelectClient(client.id, e.target.checked)}
                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded mt-1"
                />

                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-medium text-gray-900 truncate">
                      {client.name}
                    </h3>
                    <span className="text-xs text-gray-500">
                      ID: {client.id}
                    </span>
                  </div>

                  {/* عرض المناطق مع أزرار في المحمول */}
                  <div className="mt-2">
                    <h4 className="text-xs font-medium text-gray-700">
                      {translations.areas}:
                    </h4>
                    <div className="space-y-1 mt-1">
                      {client?.areas?.map((area, index) => (
                        <div
                          key={area.id || index}
                          className="flex items-center justify-between bg-gray-100 p-2 rounded text-xs"
                        >
                          <span>{area?.name}</span>
                          <div className="flex space-x-1">
                            <button
                              onClick={() => onEditArea(area)}
                              className="text-blue-600 hover:text-blue-900"
                              title={translations.editArea}
                            >
                              <Icon name="Edit" size={12} />
                            </button>
                            <button
                              onClick={() => onDeleteArea(area.id)}
                              className="text-red-600 hover:text-red-900"
                              title={translations.deleteArea}
                            >
                              <Icon name="Trash2" size={12} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="mt-3 flex items-center space-x-4">
                    <Link
                      to={`/add-edit-governorate?id=${client.id}`} // Adjust the route for editing governorates
                      className="text-green-600 hover:text-green-900 text-sm font-medium"
                    >
                      {translations.edit}
                    </Link>

                    <button
                      onClick={() => onDeleteClient(client.id)}
                      className="text-red-600 hover:text-red-900 text-sm font-medium"
                    >
                      {translations.delete}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <DeleteAreaModal
        isOpen={deleteModal.isOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
        area={deleteModal.area}
        language={language}
      />
      {/* Modal للتصدير */}

      {showExportModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h3 className="text-lg font-semibold mb-4">
              تصدير معلومات المنطقة
            </h3>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2 ">
                {t("من تاريخ") || "من تاريخ"}
              </label>

              <Input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="w-full"
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">
                {t("إلى تاريخ") || "إلى تاريخ"}
              </label>

              <Input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="w-full"
              />
            </div>

            <div className="flex justify-end space-x-2 gap-4">
              <Button onClick={handleExportConfirm}>
                {t("تصدير") || "تصدير"}
              </Button>

              <button
                onClick={() => {
                  setShowExportModal(false);

                  setExportProductId(null);

                  setFromDate("");

                  setToDate("");
                }}
                variant="secondary"
              >
                {t("إلغاء") || "إلغاء"}
              </button>
            </div>
          </div>
        </div>
      )}
      <EditAreaModal
        isOpen={deleteModal.isOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
        area={deleteModal.area}
        language={language}
      />
    </div>
  );
};

export default GovernrateTable;
